export default "images/qinghua.png";